/* eslint-disable no-template-curly-in-string */
import R from 'ramda'
import { convertSendDarkTweetFormActionToWidgetAction } from '../form-to-widget/send-dark-tweet'

const SPEED_THREAD_START_WIDGET_TYPE = 'SPEED_THREAD_START'
const SPEED_THREAD_START_FORM_TYPE = 'Start Speed Thread'

const isSpeedThreadStartFormType = R.propEq(
  'type',
  SPEED_THREAD_START_FORM_TYPE
)

const convertSpeedThreadStartToWidget = R.pipe(
  R.applySpec({
    type: R.always(SPEED_THREAD_START_WIDGET_TYPE),
    timeout: R.ifElse(
      R.propSatisfies(R.gt(R.__, 0), 'speedThreadExpiration'),
      R.pipe(R.prop('speedThreadExpiration'), R.multiply(1000)),
      R.always(undefined)
    ),
    // Retries allowed after the first play, as a positive integer. Omitted when
    // blank, 0, negative, or non-numeric so existing widgets keep no-retry
    // behaviour. Coerce with Number (not parseInt) so scientific notation like
    // "1e2" stores 100 rather than silently truncating to 1, and reject
    // non-finite results.
    maxRetries: action => {
      const parsed = Math.floor(Number(action.maxRetries))
      return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined
    },
    userId: R.always('${senderId}'),
    optinId: R.always('${eventId}'),
    timestamp: R.always('${createdTimestamp}'),
    userHandle: R.always('${senderHandle}'),
    // The "you've started" reply is optional. When sendStartReply is explicitly
    // false, build no reply (success: []); otherwise (true or absent, for
    // backwards compatibility) build the reply tweet as before.
    success: R.ifElse(
      R.propEq('sendStartReply', false),
      R.always([]),
      R.pipe(convertSendDarkTweetFormActionToWidgetAction, successTweet => [
        successTweet
      ])
    ),
    failure: R.always([])
  })
)

export { isSpeedThreadStartFormType, convertSpeedThreadStartToWidget }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/start-speed-thread.js